import lib from "./../../js-lib/lib.js";

const Stylesheet = {
  render: (state) => {
    if (state.eco.current == "disabled") {
      if (!lib.id("stylesheet-performance")) {
        lib.stylesheet.add(
          lib.siteurl() +
            "/wp-content/themes/holland-engineering-2023/static/performance.css",
          "stylesheet-performance"
        );
      }
    } else {
      lib.stylesheet.remove("stylesheet-performance");
    }
  },
};

export { Stylesheet as default };
